import { format } from "date-fns";

interface IOptions {
  day: "2-digit";
  month: "2-digit";
  year: "numeric";
}
const options: IOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
};

export const displayDate = (date: Date) => new Date(date).toLocaleDateString("de-DE", options);

export const javaDateToJS = (date: string | Date): Date => {
  if (date instanceof Date) {
    return date;
  } else {
    return new Date(date.includes("+") ? date.replace("+", ".") + "Z" : date);
  }
};

export const dateWithoutTime = (date: Date) => {
  const tempDate = new Date(date);
  tempDate.setHours(0, 0, 0, 0);
  return tempDate;
};

/**
 * Returns the date in a format that Google Calendar will accept.
 * We need a from date and a to date but since we don't have that
 * we return the same date twice
 * @param date
 */
export const dateForGoogleCal = (date: Date) =>
  `${format(date, "YYYMMdd")}T${format(date, "HHmmss")}Z/${format(date, "YYYMMdd")}T${format(date, "HHmmss")}Z`;
